import React, {forwardRef} from 'react'
import PropTypes from 'prop-types'

import {Section} from "../../02-Molecules/Section/Section"
import {FormCheckbox} from "../../01-Atoms/FormCheckbox/FormCheckbox";

/**
 * SectionOptins component.
 */
export const SectionOptins = forwardRef(({ collapsed, heading, headingLarge, sectionId, sectionClass, staticText, tracking, trackEvent, ...props }, ref) => {

  /**
   * Handle any form changes.
   *
   * @param {string} name
   *   The value name
   *
   * @param {boolean} isChecked
   *   A boolean indicating if the checkbox is checked
   */
  const handlerInputChange = (name, isChecked) => {
    props.onInputChange(name, isChecked ? 'Y' : '')
  }

  return (
    <Section sectionClass={'callout'} tracking={tracking} trackEvent={trackEvent} collapsed={collapsed} heading={heading} headingLarge={headingLarge} sectionId={sectionId} textAfter={staticText.optins.text_after} textBefore={staticText.optins.text_before}>
      <FormCheckbox
        checked={props.values.optin_email === 'Y'}
        label={staticText.optins.email_option_label}
        name={'optin_email'}
        onInputChange={handlerInputChange}
      />

      {props.values.telephone_number ?
        <FormCheckbox
          checked={props.values.telephone_number === 'Y'}
          label={staticText.optins.telephone_option_label}
          name={'optin_telephone'}
          onInputChange={handlerInputChange}
        /> : null
      }

    </Section>
  )
})

/**
 * SectionOptins PropTypes.
 */
SectionOptins.propTypes = {
  collapsed    : PropTypes.bool,
  heading      : PropTypes.string,
  headingLarge : PropTypes.bool,
  sectionId    : PropTypes.string,
  sectionClass : PropTypes.string,
  onInputChange: PropTypes.func,
  staticText   : PropTypes.shape({
    optins: PropTypes.shape({
      text_before           : PropTypes.string,
      email_option_label    : PropTypes.string,
      telephone_option_label: PropTypes.string,
      text_after            : PropTypes.string,
    })
  }),
  tracking: PropTypes.shape({
    id  : PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    type: PropTypes.oneOf(['entry', 'exit', 'entry_exit'])
  }),
  trackEvent: PropTypes.func,
  values       : PropTypes.shape({
    optin_email     : PropTypes.string,
    optin_telephone : PropTypes.string,
    telephone_number: PropTypes.string,
  })
}
